import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      userManagement: {
        ...store.getState().i18n.translations.en.userManagement,
        availablePackage: {
          AVAILABLE_PACKAGE: 'Available Package',
          PACKAGE_TYPE: 'Package Type',
          PURCHASE_DATE: 'Purchase Date',
          EXPIRY_DATE: 'Expiry Date',
          PACKAGE_TYPES: 'Package Types',
          VOLUME: 'Volume',
          REMAINING: 'Remaining',
          BUY_PACKAGE: 'Buy Package',
          ALL: 'All',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      userManagement: {
        ...store.getState().i18n.translations.vi.userManagement,
        availablePackage: {
          AVAILABLE_PACKAGE: 'Gói Sẵn Có',
          PACKAGE_TYPE: 'Loại Gói',
          PURCHASE_DATE: 'Ngày Mua',
          EXPIRY_DATE: 'Ngày Hết Hạn',
          PACKAGE_TYPES: 'Loại Gói',
          VOLUME: 'Số Lượng',
          REMAINING: 'Số Dư',
          BUY_PACKAGE: 'Mua Gói',
          ALL: 'Tất Cả',
        },
      },
    },
  }),
)
